/**
 * Offer slider
 *
 * Used by offers and events.
 *
 * Refactor in future if their needs really diverge. However, for now, they are
 * very similar and it's easier to keep them in sync if they are in the same
 * file.
 */
var cor_sync_offer_collection_heights = function(wrapper, selectors) {

  if (!wrapper || !selectors) {
    return;
  }

  const cards = wrapper.querySelectorAll(selectors.card);
  const mediaBlocks = wrapper.querySelectorAll(selectors.media);
  if (!cards.length) {
    return;
  }

  let maxMediaHeight = 0;

  for (var i = 0; i < mediaBlocks.length; i++) {
    mediaBlocks[i].style.minHeight = '';
  }

  for (var j = 0; j < mediaBlocks.length; j++) {
    maxMediaHeight = Math.max(maxMediaHeight, mediaBlocks[j].offsetHeight);
  }

  for (var k = 0; k < mediaBlocks.length; k++) {
    mediaBlocks[k].style.minHeight = maxMediaHeight + 'px';
  }

  const hasExpandedCard = wrapper.querySelector('.js-offer-expand-card:not(.is-collapsed)') !== null;
  if (hasExpandedCard) {
    return;
  }

  let maxHeight = 0;

  for (var l = 0; l < cards.length; l++) {
    cards[l].style.minHeight = '';
  }

  for (var m = 0; m < cards.length; m++) {
    maxHeight = Math.max(maxHeight, cards[m].offsetHeight);
  }

  for (var n = 0; n < cards.length; n++) {
    cards[n].style.minHeight = maxHeight + 'px';
  }
};

var cor_bind_offer_height_sync = function(wrapper, selectors) {

  if (!wrapper || wrapper.getAttribute('data-height-sync-init') !== null) {
    return;
  }

  wrapper.setAttribute('data-height-sync-init', 'true');

  const images = wrapper.querySelectorAll(selectors.image);

  const syncHeights = function() {
    cor_sync_offer_collection_heights(wrapper, selectors);
  };

  window.addEventListener('load', syncHeights);
  window.addEventListener('resize', syncHeights);
  document.addEventListener('lazyloaded', function(e) {
    if (!wrapper.contains(e.target)) {
      return;
    }

    syncHeights();
  });

  for (var i = 0; i < images.length; i++) {
    if (images[i].complete) {
      continue;
    }

    images[i].addEventListener('load', syncHeights);
  }
};

var cor_offer_height_sync_selectors = {
  slider: {
    card: '.js-offer-slide .offer',
    media: '.js-offer-slide .offer__media',
    image: '.js-offer-slide .offer__media img',
  },
  grid: {
    card: '.offer',
    media: '.offer__media',
    image: '.offer__media img',
  },
};

var cor_offer_slider = function() {

  const wrappers = document.querySelectorAll('.js-offer-slider-wrapper');
  for (var i = 0; i < wrappers.length; i++) {

    if (wrappers[i].getAttribute('data-init') !== null) {
      continue;
    }
    wrappers[i].setAttribute('data-init', 'true');

    const addArrowEvents = (instance) => {
      els.prev.addEventListener("click", () => instance.prev());
      els.next.addEventListener("click", () => instance.next());
    };

    const maybeDisableArrows = (instance) => {
      const slidesPerView = Math.floor(instance.options.slides.perView);
      const size = instance.slides.length;
      const relativeSlide = instance.track.details.rel;
      els.prev.disabled = relativeSlide === 0;
      els.next.disabled = relativeSlide === size - slidesPerView;
      els.wrapper.classList.toggle('is-arrows-hidden', els.prev.disabled && els.next.disabled);

    };

    const buildDots = (instance) => {
      const slidesPerView = Math.floor(instance.options.slides.perView);
      const numOfDots = els.slides.length - slidesPerView + 1;
      els.dots.innerHTML = "";
      for (let i = 0; i < numOfDots; i++) {
        const dot = document.createElement("button");
        dot.addEventListener("click", () => instance.moveToIdx(i));
        dot.setAttribute("aria-label", 'Siirry kohtaan ' + i);
        els.dots.appendChild(dot);
      }
      els.wrapper.classList.toggle('is-dots-hidden', numOfDots <= 1)
    };

    const setActiveDots = (instance) => {
      const relativeSlide = instance.track.details.rel;
      const dots = els.dots.querySelectorAll("button");
      for (let i = 0; i < dots.length; i++) {
        dots[i].classList.toggle("is-active", relativeSlide === i);
      };
    };

    const setActiveSlides = (instance) => {
      const slidesPerView = Math.floor(instance.options.slides.perView);
      const relativeSlide = instance.track.details.rel;
      for (let i = 0; i < els.slides.length; i++) {
        els.slides[i].classList.toggle(
          "is-active",
          i >= relativeSlide && i < relativeSlide + slidesPerView
        );
      }
    };

    const wrapper = wrappers[i];
    cor_bind_offer_height_sync(wrapper, cor_offer_height_sync_selectors.slider);

    const els = {
			wrapper: wrapper,
			slider: wrapper.querySelector('.js-offer-slider'),
			slides: wrapper.querySelectorAll('.js-offer-slide'),
			prev: wrapper.querySelector('.js-offer-slider-prev'),
			next: wrapper.querySelector('.js-offer-slider-next'),
			dots: wrapper.querySelector('.js-offer-slider-dots'),
		};

    var count = parseInt(els.slider.getAttribute('data-count'));
    let args = {
      breakpoints: {},
      slides: {
        // loop: true,
        spacing: 14,
        perView: 1.075,
      },
			created: function(instance) {
				addArrowEvents(instance);
				buildDots(instance);
				maybeDisableArrows(instance);
				setActiveDots(instance);
				setActiveSlides(instance);
        cor_sync_offer_collection_heights(els.wrapper, cor_offer_height_sync_selectors.slider);
			},
			slideChanged: function(instance) {
				maybeDisableArrows(instance);
				setActiveDots(instance);
				setActiveSlides(instance);
			},
      optionsChanged: function(instance) {
        buildDots(instance);
				maybeDisableArrows(instance);
        setActiveDots(instance);
				setActiveSlides(instance);
        cor_sync_offer_collection_heights(els.wrapper, cor_offer_height_sync_selectors.slider);
      },
			mounted: function() {
				els.wrapper.classList.add("is-ready");
        cor_sync_offer_collection_heights(els.wrapper, cor_offer_height_sync_selectors.slider);
			},
    }
    if (count == 2) {
      args.breakpoints['(min-width: 620px)'] = {
        slides: {
          perView: 2,
          spacing: 16,
        }
      };
    }
    if (count > 2) {
      args.breakpoints['(min-width: 620px)'] = {
        slides: {
          perView: 2.25,
          spacing: 18,
        }
      };
      args.breakpoints['(min-width: 768px)'] = {
        slides: {
          perView: 2.5,
          spacing: 20,
        }
      };
    }
    if (count == 3) {
      args.breakpoints['(min-width: 1024px)'] = {
        slides: {
          perView: 3,
          spacing: 20,
        }
      };
    }
    if (count > 3) {
      args.breakpoints['(min-width: 1024px)'] = {
        slides: {
          perView: 3,
          spacing: 20,
        }
      };
      args.breakpoints['(min-width: 1500px)'] = {
        slides: {
          perView: 4,
          spacing: 20,
        }
      };
    }

    var slider_instance = new KeenSlider(els.slider, args);
    els.wrapper.classList.add("is-ready");
  }

};

var cor_offer_grids = function() {

  const wrappers = document.querySelectorAll('.js-offer-height-sync');

  for (var i = 0; i < wrappers.length; i++) {
    cor_bind_offer_height_sync(wrappers[i], cor_offer_height_sync_selectors.grid);
    cor_sync_offer_collection_heights(wrappers[i], cor_offer_height_sync_selectors.grid);
  }
};

var cor_offer_expanders = function() {

  const toggles = document.querySelectorAll('.js-offer-expand-toggle');
  const cardSelector = '.js-offer-expand-card';
  const interactiveSelector = 'a, button, input, select, textarea, summary, [role="button"]';
  const hiddenFocusableSelector = 'a, button, input, select, textarea, summary, [tabindex]';

  const updateSlider = (toggle) => {
    const sliderElement = toggle.closest('.js-offer-slider');
    if (!sliderElement || !sliderElement.keenSlider) {
      return;
    }

    sliderElement.keenSlider.update();
  };

  const setCollapsedFocusState = (content, isExpanded) => {
    if (!content) {
      return;
    }

    const focusableElements = content.querySelectorAll(hiddenFocusableSelector);

    for (var j = 0; j < focusableElements.length; j++) {
      const element = focusableElements[j];

      if (isExpanded) {
        if (element.hasAttribute('data-offer-original-tabindex')) {
          const originalTabIndex = element.getAttribute('data-offer-original-tabindex');
          if (originalTabIndex === '') {
            element.removeAttribute('tabindex');
          } else {
            element.setAttribute('tabindex', originalTabIndex);
          }
          element.removeAttribute('data-offer-original-tabindex');
        } else if (element.getAttribute('tabindex') === '-1') {
          element.removeAttribute('tabindex');
        }

        element.removeAttribute('aria-hidden');
        continue;
      }

      if (!element.hasAttribute('data-offer-original-tabindex')) {
        element.setAttribute('data-offer-original-tabindex', element.getAttribute('tabindex') || '');
      }

      element.setAttribute('tabindex', '-1');
      element.setAttribute('aria-hidden', 'true');
    }
  };

  const moveFocusToCardTitle = (card) => {
    if (!card) {
      return;
    }

    const title = card.querySelector('.js-offer-title');
    if (!title) {
      return;
    }

    if (!title.hasAttribute('tabindex')) {
      title.setAttribute('tabindex', '-1');
    }

    title.focus();
  };

  const expandCard = (toggle, content, moveFocus) => {
    if (!toggle || !content || toggle.hidden) {
      return;
    }

    const card = toggle.closest(cardSelector);

    toggle.setAttribute('aria-expanded', 'true');
    content.classList.remove('is-collapsed');
    setCollapsedFocusState(content, true);
    toggle.hidden = true;

    if (card) {
      card.classList.remove('is-collapsed');
    }

    if (moveFocus) {
      moveFocusToCardTitle(card);
    }

    updateSlider(toggle);
  };

  for (var i = 0; i < toggles.length; i++) {
    const toggle = toggles[i];

    if (toggle.getAttribute('data-init') !== null) {
      continue;
    }

    const content = toggle.parentNode.querySelector('.js-offer-expandable-content');
    const card = toggle.closest(cardSelector);

    if (!content) {
      toggle.hidden = true;
      continue;
    }

    const hasOverflow = content.scrollHeight - content.clientHeight > 4;

    if (!hasOverflow) {
      content.classList.remove('is-collapsed');
      setCollapsedFocusState(content, true);
      if (card) {
        card.classList.remove('is-collapsed');
      }
      toggle.hidden = true;
      continue;
    }

    toggle.setAttribute('data-init', 'true');
    setCollapsedFocusState(content, false);
    if (card) {
      card.classList.add('is-collapsed');
    }

    toggle.addEventListener('click', function(e) {
      e.stopPropagation();
      expandCard(e.currentTarget, e.currentTarget.parentNode.querySelector('.js-offer-expandable-content'), true);
    });

    if (card) {
      card.addEventListener('click', function(e) {
        if (e.target.closest(interactiveSelector)) {
          return;
        }

        const currentCard = e.currentTarget;
        const currentToggle = currentCard.querySelector('.js-offer-expand-toggle');
        const currentContent = currentCard.querySelector('.js-offer-expandable-content');

        expandCard(currentToggle, currentContent, false);
      });
    }
  }

  const wrappers = document.querySelectorAll('.js-offer-slider-wrapper');
  for (var j = 0; j < wrappers.length; j++) {
    cor_sync_offer_collection_heights(wrappers[j], cor_offer_height_sync_selectors.slider);
  }
};

document.addEventListener('DOMContentLoaded', cor_offer_slider);
document.addEventListener('GrowthstackABTestReplacementAfter', cor_offer_slider);
document.addEventListener('DOMContentLoaded', cor_offer_grids);
document.addEventListener('GrowthstackABTestReplacementAfter', cor_offer_grids);
document.addEventListener('DOMContentLoaded', cor_offer_expanders);
document.addEventListener('GrowthstackABTestReplacementAfter', cor_offer_expanders);
